export function phoneDigits(value) {
  return String(value || '').replace(/\D/g, '')
}

/** @param {{ phone?: string, whatsapp?: string } | null | undefined} contact */
export function getWhatsAppContact(contact) {
  const label = String(contact?.whatsapp || contact?.phone || '').trim()
  const tel = phoneDigits(label)
  if (!tel) return null
  return {
    tel,
    label,
    href: `https://wa.me/${tel}`,
  }
}
